import React from "react";
import { DateTimeFormat } from "../../helpers/utils";
import TableBase from "./Base";

const MobileVersionsTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Version",
			dataIndex: "version",
			width: 100,
			ellipsis: true,
		},
		{
			title: "Description",
			dataIndex: "description",
			width: 200,
			ellipsis: true,
		},
		{
			title: "Force Update",
			dataIndex: "force_update",
			width: 100,
			ellipsis: true,
			render(record) {
				return record === true ? "Yes" : "No";
			},
		},
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(value) {
				return <span>{DateTimeFormat(value)}</span>;
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default MobileVersionsTable;
